module.exports = __webpack_public_path__ + "fonts/proximanova-regular-webfont.dbbbb053.eot";